import { defineMessages } from 'react-intl'

export const homeStatusHostInfoMessages = defineMessages({
  hostInfo: {
    id: 'homeStatusHostInfo.hostInfo',
    description: 'Home Status block label for "Host Info"',
    defaultMessage: 'Host Info',
  },
  hostType: {
    id: 'homeStatusHostInfo.hostType',
    description: 'Home Status block label for "Host Type"',
    defaultMessage: 'Host Type',
  },
  OSVersion: {
    id: 'homeStatusHostInfo.OSVersion',
    description: 'Home Status block label for "OS Version"',
    defaultMessage: 'OS Version',
  },
})
